<script setup>

</script>

<template>
  <div id="report">数据报表</div>
</template>

<style lang="scss" scoped>
#report {
  height: 100%;
}
</style>
